// Экранирование текстов из API (названия, описания) перед innerHTML
export function esc(s) {
  return String(s ?? "").replace(
    /[&<>"']/g,
    (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[ch],
  );
}

// Многострочный текст Шелтера (\n и маркеры «•») → абзацы и списки
export function richText(text) {
  const lines = String(text ?? "")
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean);
  let html = "";
  let list = [];
  const flush = () => {
    if (list.length) {
      html += `<ul>${list.map((li) => `<li>${esc(li)}</li>`).join("")}</ul>`;
      list = [];
    }
  };
  for (const line of lines) {
    if (line.startsWith("•") || line.startsWith("-")) list.push(line.replace(/^[•-]\s*/, ""));
    else {
      flush();
      html += `<p>${esc(line)}</p>`;
    }
  }
  flush();
  return html;
}
